<div class="flex justify-between items-center bg-gray-200 p-4 pr-[18px] text-xl min-h-14">
  <div class="flex-1 flex gap-2 items-center">
    <strong>{{ title() }}</strong>
    <ng-content></ng-content>
  </div>

  <ng-content select="[action]"></ng-content>
</div>
